export enum EmploymentTypes {
  'W2' = 1,
  'M1099' = 2,
  'K1' = 3
}
